import axios from 'axios';

async function validateTaxNumberRequest(countryID, taxNumber, cancelToken) {
  try {
    const res = await axios.post(
      `/validateTaxNumber?countryID=${countryID}&taxNumber=${taxNumber}`,
      {},
      { cancelToken }
    );
    return res.data;
  } catch (err) {
    if (axios.isCancel(err)) {
      console.log('Request canceled', err.message);
    } else {
      console.error(err);
      throw err;
    }
  }
}

export default validateTaxNumberRequest;

export async function getBlockedTaxNumbers() {
  return (await axios.get(`/blocked-tax-numbers`)).data;
}
